import { getRawMessage } from '../locale'

export const networkError = getRawMessage('general.error.500')
export const generalFormError = getRawMessage('general.error.form')
